import { createFileRoute } from "@tanstack/react-router";
import SignupSources from "@/pages/admin/SignupSources";
import { MainLayout } from "@/components/layout/MainLayout";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

const T = "Sign-up Sources | Statlign Admin";
const D = "See which Facebook ad brought each new member and how many credits they spent.";

export const Route = createFileRoute("/admin/signup-sources")({
  head: () => ({
    meta: [
      { title: T },
      { name: "description", content: D },
      { property: "og:title", content: T },
      { property: "og:description", content: D },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <MainLayout>
      <ProtectedRoute requiredRole="admin">
        <SignupSources />
      </ProtectedRoute>
    </MainLayout>
  ),
});
